/* ============================================================
   Zenoura native cart bridge — Phase 5
   Model:
   1) QUANTITY = variant composition, no Shopify discount.
      unitQty -> packQty = floor(u/2), singleQty = u%2. The cart holds the real
      pack (2-stk) + single (1-stk) price-SKUs, so checkout is correct natively
      and lines never split from a discount allocation.
   2) CROSS-PRODUCT = a single native discount code, chosen by the JS router and
      applied via /cart/update.js ({discount:"CODE"} / {discount:""} to clear).
      Rules are mutually exclusive so one code per cart is always enough.
   3) DISPLAY = server-grouped rows (cart.ajax view): one line per product,
      Shopify-computed price. No JS-computed prices.

   Requires the Qikify Slide Cart app embed to be OFF.
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Cross-product discount codes — confirmed active in Shopify Admin
     (Benji, 2026-07-06). If a code is later renamed/deactivated in Admin,
     applying it is a harmless no-op and the router only console-logs — the
     storefront keeps promising the discount, so verify Admin after changes. */
  var CODE_PRO_PULSE = 'ZN-PP200-4KX7'; // 200 kr off Zen Pulse when Zen Pro is in cart
  var CODE_RUTINE    = 'ZN-RUT15-9F3A2'; // 15% off order when 2+ distinct products

  // 395-bundlen (ZN-PP200) maa ikke modsige 15 %-beskeden (Benji 13/10 2026).
  // false = router og kurv bruger KUN rutinerabatten; true = den gamle regel,
  // hvor praecis Zen Pro + Zen Pulse fik 200 kr og kurven viste 395-nudgen.
  var BUNDLE_395_WINS = false;

  // Varer der IKKE taeller som "andet produkt" i 15 %-reglen og aldrig vises
  // som forslag (13/10 2026): e-bogen foelger gratis med i ethvert koeb, og
  // Zen Pro + e-bog med 15 % blev billigere end Zen Pro alene. Handlen er
  // haardkodet som i snippets/zenoura-vaerdipakke.liquid (ingen indstilling).
  var UNDTAGET_HANDLES = ['ro-i-laenden-e-bog'];
  function erUndtaget(h) { return UNDTAGET_HANDLES.indexOf(h) > -1; }

  // Kundeteksten i 1-vare-tilstanden. Samme ordlyd i Liquid (cart-drawer +
  // main-cart), saa de to flader siger det samme.
  var OFFER_ONE = 'Tilføj 1 produkt mere, og få 15 % på hele købet';
  // B3 (19/10 2026): overskriften, naar rutinerabatten er slaaet fra (data-zen-rutine="off").
  // Forslagene vises stadig; kun 15 %-loeftet er vaek. Samme ordlyd i cart-drawer + main-cart.
  var OFFER_PLAIN = 'Passer til din kurv';

  function onCartPage() {
    return !!(document.body && document.body.classList.contains('template-cart'));
  }

  // Shopify leverer beloebet i oere; her formateres det kun (1.234 kr /
  // 1.234,50 kr), som Liquids money_without_trailing_zeros. Aldrig regnet.
  function fmtKr(cents) {
    var n = Math.round(Number(cents) || 0);
    var kr = Math.floor(n / 100), ore = n % 100;
    var s = String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (ore) s += ',' + (ore < 10 ? '0' : '') + ore;
    return s + ' kr';
  }

  // Open Motion's drawer via its own opener, but cancel the opener anchor's
  // href navigation so a programmatic open never lands on /cart.
  function openDrawer() {
    var opener = document.querySelector('.js-drawer-open-cart');
    if (!opener) return false;
    var stop = function (e) { e.preventDefault(); };
    opener.addEventListener('click', stop);
    opener.click();
    opener.removeEventListener('click', stop);
    return true;
  }

  function setBubble(count) {
    var host = document.querySelector('.cart-link');
    var bubble = document.querySelector('.cart-link__bubble');
    if (count > 0) {
      if (!bubble && host) {
        bubble = document.createElement('span');
        bubble.className = 'cart-link__bubble';
        host.appendChild(bubble);
      }
      if (bubble) bubble.classList.add('cart-link__bubble--visible');
    } else if (bubble) {
      bubble.classList.remove('cart-link__bubble--visible');
    }
  }

  // Re-render the drawer contents from the server (grouped cart.ajax view) and
  // sync the footer totals + header bubble. Cache-bust so freshly-pushed markup
  // (qty, price, buttons) is never served stale.
  function refresh() {
    return fetch(root + 'cart?view=ajax&_=' + Date.now(), { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var freshItems = tmp.querySelector('.cart__items');
        var freshDiscounts = tmp.querySelector('.cart__discounts');

        var products = document.querySelector('[data-products]');
        if (products && freshItems) products.innerHTML = freshItems.outerHTML;
        renderCartDelivery();

        var liveDiscounts = document.querySelector('[data-discounts]');
        if (liveDiscounts && freshDiscounts) {
          liveDiscounts.innerHTML = freshDiscounts.innerHTML;
          // Sync the hide-state too, so an empty "Rabat" label row never lingers
          // when there is no active cart-level discount.
          liveDiscounts.classList.toggle('hide', freshDiscounts.classList.contains('hide'));
        }

        // Vaerdipakken (byggespec afsnit 5): garanti-labelen og guide-linjen
        // bygges server-side i cart.ajax og kopieres over, saa de passer til
        // kurven efter hver aendring (fx naar Zen Pro fjernes).
        var freshVp = tmp.querySelector('[data-zvp-src]');
        if (freshVp) {
          var vpTrust = freshVp.getAttribute('data-zvp-trust');
          if (vpTrust) {
            document.querySelectorAll('#CartDrawer [data-zvp-trust]').forEach(function (el) { el.textContent = vpTrust; });
          }
          var vpSlot = document.querySelector('[data-zvp-cart-slot]');
          if (vpSlot) vpSlot.innerHTML = freshVp.innerHTML.trim();
        }

        var count = 0;
        if (freshItems) {
          count = parseInt(freshItems.getAttribute('data-count'), 10) || 0;

          var subtotal = freshItems.getAttribute('data-subtotal-display');
          var sub = document.querySelector('[data-subtotal]');
          if (sub && subtotal) sub.innerHTML = subtotal;

          // Mirror the total onto the checkout CTA so the customer commits with the number in view.
          var ctTotal = document.querySelector('[data-checkout-total]');
          if (ctTotal && subtotal) ctTotal.innerHTML = subtotal;

          var savingsEl = document.querySelector('[data-savings]');
          if (savingsEl) {
            // Contextual copy is built server-side in cart.ajax.liquid (never a
            // code name). Hide the box entirely when there's no cart-level saving.
            var savingsLabel = freshItems.getAttribute('data-savings-label');
            if (freshItems.hasAttribute('data-cart-savings') && savingsLabel) {
              savingsEl.innerHTML = '<div>' + savingsLabel + '</div>';
              savingsEl.classList.remove('hide');
            } else {
              savingsEl.classList.add('hide');
            }
          }
        }

        var drawer = document.getElementById('CartDrawer');
        if (drawer) drawer.classList.toggle('is-empty', count === 0);
        setBubble(count);

        var countEl = document.querySelector('[data-zcart-count]');
        if (countEl) countEl.textContent = count;
        updateUpsell();

        return count;
      });
  }

  /* ---- Discount router (single code, via /cart/update.js) ---------------- */
  function getCart() {
    return fetch(root + 'cart.js', { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  /* ---- E-bogen gratis med (Benji 13/10 2026) -----------------------------
     "E-bogen skal være gratis med zenpro uden at give rabat samlet."
     Prisen saettes af en automatisk Shopify-rabat ("Koeb X, faa Y": 1 stk af
     en vare fra zen_vp_guide_handles giver 1 e-bog til 100 %). Temaet laegger
     kun e-bogen i kurven og tager den ud igen:
       - en vare fra listen i kurven, ingen e-bog: e-bogen laegges i med
         _zen_gratis = 1 (underscore = skjult i kassen)
       - ingen vare fra listen: den automatiske e-bog fjernes (ellers kostede
         den pludselig 249 kr). En e-bog kunden selv har lagt i, roeres ikke.
       - kunden har selv lagt e-bogen i: den automatiske linje fjernes, saa
         e-bogen kun staar der een gang (Shopify goer kundens linje gratis)
       - den automatiske linje holdes paa antal 1
       - skudsikring: koster den automatiske e-bog mere end 0 kr (rabatten
         er ikke aktiv), tages den ud igen med det samme, og der proeves ikke
         igen de naeste 10 minutter. Saa vises informationskortet som foer.
     Hoejst een runde skrivninger pr. kald og aldrig rekursivt, saa det kan
     ikke loebe i ring. */
  var EBOG_HANDLE = 'ro-i-laenden-e-bog';
  var GIFT_PROP = '_zen_gratis';
  var GIFT_BLOCK_KEY = 'zenGiftBlockedAt';
  var GIFT_BLOCK_MS = 10 * 60 * 1000;
  var giftBlockedPage = false;

  function giftCfg() {
    var el = document.querySelector('[data-zen-gift-variant]');
    if (!el) return null;
    var vid = parseInt(el.getAttribute('data-zen-gift-variant'), 10);
    if (!vid) return null;
    var handles = String(el.getAttribute('data-zen-gift-handles') || '').split(',')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s && s !== EBOG_HANDLE; });
    if (!handles.length) return null;
    return { variant: vid, handles: handles };
  }
  function isAutoGift(it) {
    return !!(it && it.handle === EBOG_HANDLE && it.properties && String(it.properties[GIFT_PROP]) === '1');
  }
  function giftBlocked() {
    if (giftBlockedPage) return true;
    try {
      var t = parseInt(window.sessionStorage.getItem(GIFT_BLOCK_KEY), 10);
      return !!t && (Date.now() - t) < GIFT_BLOCK_MS;
    } catch (e) { return false; }
  }
  function blockGift(sessionToo) {
    giftBlockedPage = true;
    if (!sessionToo) return;
    try { window.sessionStorage.setItem(GIFT_BLOCK_KEY, String(Date.now())); } catch (e) {}
  }
  function postCart(path, body) {
    return trackInflight(fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }));
  }

  // Tager kurven ind, retter e-bogen (hoejst een runde) og giver den aktuelle
  // kurv tilbage. Kaster aldrig: ved fejl gives den oprindelige kurv tilbage.
  function ensureGift(cart) {
    var cfg = giftCfg();
    if (!cart || !cfg) return Promise.resolve(cart);
    var items = cart.items || [];
    var hasQual = items.some(function (it) { return cfg.handles.indexOf(it.handle) > -1; });
    var auto = items.filter(isAutoGift);
    var manual = items.filter(function (it) { return it.handle === EBOG_HANDLE && !isAutoGift(it); });
    var updates = {}, n = 0, add = false;
    function zero(it) { updates[it.key] = 0; n++; }

    if (!hasQual || manual.length) {
      auto.forEach(zero);
    } else if (auto.length) {
      auto.forEach(function (it, i) {
        if (i > 0) zero(it);
        else if (it.quantity !== 1) { updates[it.key] = 1; n++; }
        else if (Number(it.final_line_price) > 0) { zero(it); blockGift(true); }
      });
    } else if (!giftBlocked()) {
      add = true;
    }
    if (!n && !add) return Promise.resolve(cart);

    var step = n ? postCart('cart/update.js', { updates: updates }) : Promise.resolve();
    if (add) {
      step = step.then(function () {
        var props = {}; props[GIFT_PROP] = '1';
        return postCart('cart/add.js', { items: [{ id: cfg.variant, quantity: 1, properties: props }] });
      });
    }
    return step.then(getCart).then(function (c2) {
      if (!add) return c2;
      var mine = (c2.items || []).filter(isAutoGift);
      // Add.js afvist (fx udsolgt): proev ikke igen paa denne side.
      if (!mine.length) { blockGift(false); return c2; }
      var paid = mine.filter(function (it) { return Number(it.final_line_price) > 0; });
      if (!paid.length) return c2;
      blockGift(true);
      var u = {};
      paid.forEach(function (it) { u[it.key] = 0; });
      return postCart('cart/update.js', { updates: u }).then(getCart);
    }).catch(function () { return cart; });
  }

  /* ---- Black Month-gaven (3/11 2026) ----------------------------------
     Koeber kunden for mindst zen_bw_gave_min (fuld linjepris uden gaven selv,
     e-bogen og automatiske linjer), goer Shopifys "Koeb X, faa Y"-rabat 1 stk
     af gaveproduktet gratis. Temaet laegger kun gaven i og tager den ud igen,
     praecis som e-bogen ovenfor:
       - kunden har selv lagt gaven i (ingen property): den automatiske fjernes
       - basis under minimum: den automatiske fjernes
       - basis naaet: hoejst 1 automatisk linje med antal 1; koster den mere end
         0 kr (rabatten er ikke aktiv), tages den ud, og der proeves ikke igen de
         naeste 10 minutter (body.zen-gave-blokeret skjuler baren)
       - gaven slukket (ingen data-zen-gave-* paa #CartDrawer): kun skudsikring;
         en tidligere automatisk gave, der nu koster penge, tages ud
     Hoejst een runde skrivninger pr. kald, aldrig rekursivt, kaster aldrig. */
  var GAVE_PROP = '_zen_gave';
  var GAVE_BLOCK_KEY = 'zenGaveBlockedAt';
  var GAVE_BLOCK_MS = 10 * 60 * 1000;
  var gaveBlockedPage = false;

  function gaveCfg() {
    var el = document.getElementById('CartDrawer');
    if (!el) return null;
    var vid = parseInt(el.getAttribute('data-zen-gave-variant'), 10);
    var handle = String(el.getAttribute('data-zen-gave-handle') || '').trim();
    var min = parseInt(el.getAttribute('data-zen-gave-min'), 10);
    if (!vid || !handle || !(min > 0)) return null;
    return { variant: vid, handle: handle, min: min };
  }
  function hasGaveProp(it) {
    return !!(it && it.properties && String(it.properties[GAVE_PROP]) === '1');
  }
  function gaveBasis(items, cfg) {
    var sum = 0;
    (items || []).forEach(function (it) {
      if (!it || it.handle === cfg.handle || it.handle === EBOG_HANDLE) return;
      if (hasGaveProp(it)) return;
      if (it.properties && String(it.properties[GIFT_PROP]) === '1') return;
      sum += Number(it.original_line_price) || 0;
    });
    return sum;
  }
  function gaveBlocked() {
    if (gaveBlockedPage) return true;
    try {
      var t = parseInt(window.sessionStorage.getItem(GAVE_BLOCK_KEY), 10);
      return !!t && (Date.now() - t) < GAVE_BLOCK_MS;
    } catch (e) { return false; }
  }
  function gaveSessionBlocked() {
    try {
      var t = parseInt(window.sessionStorage.getItem(GAVE_BLOCK_KEY), 10);
      return !!t && (Date.now() - t) < GAVE_BLOCK_MS;
    } catch (e) { return false; }
  }
  function markGaveBlocked() {
    try { if (document.body) document.body.classList.add('zen-gave-blokeret'); } catch (e) {}
  }
  function blockGave(sessionToo) {
    gaveBlockedPage = true;
    if (!sessionToo) return;
    try { window.sessionStorage.setItem(GAVE_BLOCK_KEY, String(Date.now())); } catch (e) {}
    markGaveBlocked();
  }

  // Tager kurven ind, retter gaven (hoejst een runde) og giver den aktuelle
  // kurv tilbage. Kaster aldrig: ved fejl gives den oprindelige kurv tilbage.
  function ensureGave(cart) {
    try {
      if (!cart) return Promise.resolve(cart);
      var cfg = gaveCfg();
      var items = cart.items || [];
      var updates = {}, n = 0, add = false;
      var zero = function (it) { updates[it.key] = 0; n++; };

      if (!cfg) {
        items.forEach(function (it) {
          if (hasGaveProp(it) && Number(it.final_line_price) > 0) zero(it);
        });
      } else {
        // En automatisk linje med et andet produkt (gaven er skiftet) tages ud.
        items.forEach(function (it) { if (hasGaveProp(it) && it.handle !== cfg.handle) zero(it); });
        var auto = items.filter(function (it) { return it.handle === cfg.handle && hasGaveProp(it); });
        var manual = items.filter(function (it) { return it.handle === cfg.handle && !hasGaveProp(it); });
        var basis = gaveBasis(items, cfg);

        if (manual.length || basis < cfg.min) {
          auto.forEach(zero);
        } else if (auto.length) {
          auto.forEach(function (it, i) {
            if (i > 0) zero(it);
            else if (it.quantity !== 1) { updates[it.key] = 1; n++; }
            else if (Number(it.final_line_price) > 0) { zero(it); blockGave(true); }
          });
        } else if (!gaveBlocked()) {
          add = true;
        }
      }
      if (!n && !add) return Promise.resolve(cart);

      var step = n ? postCart('cart/update.js', { updates: updates }) : Promise.resolve();
      if (add) {
        step = step.then(function () {
          var props = {}; props[GAVE_PROP] = '1';
          return postCart('cart/add.js', { items: [{ id: cfg.variant, quantity: 1, properties: props }] });
        });
      }
      return step.then(getCart).then(function (c2) {
        if (!add) return c2;
        var mine = (c2.items || []).filter(function (it) { return it.handle === cfg.handle && hasGaveProp(it); });
        // Add.js afvist (fx udsolgt): proev ikke igen paa denne side.
        if (!mine.length) { blockGave(false); return c2; }
        var paid = mine.filter(function (it) { return Number(it.final_line_price) > 0; });
        if (!paid.length) return c2;
        blockGave(true);
        var u = {};
        paid.forEach(function (it) { u[it.key] = 0; });
        return postCart('cart/update.js', { updates: u }).then(getCart);
      }).catch(function () { return cart; });
    } catch (e) {
      return Promise.resolve(cart);
    }
  }

  // Apply ('CODE') or clear ('') the cart discount. Never throws — if the code
  // doesn't exist in Admin yet, Shopify simply won't apply it; we only log.
  function setDiscount(code) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  // Decide the one applicable cross-product code from the current cart, apply it,
  // then verify against /cart.js. Mutually-exclusive rules → single code only.
  function routeDiscounts() {
    // Rutinerabatten slaaet fra (data-zen-rutine="off" paa body, byggespec
    // pakke B 2026-10-10): koderne er deaktiveret i admin fra 21/10. Routeren
    // ville ellers skrive '' (eller en doed kode) til /cart/update.js og slette
    // den kode, kunden selv har indtastet. Derfor roeres rabatten slet ikke;
    // vi henter bare den aktuelle kurv, saa refresh()/open koerer som foer.
    if (document.body && document.body.getAttribute('data-zen-rutine') === 'off') {
      return getCart().then(ensureGift).then(ensureGave).catch(function () { /* never break the cart flow */ });
    }
    return getCart().then(ensureGift).then(ensureGave).then(function (cart) {
      var handles = {};
      // Den automatiske Black Month-gave (_zen_gave) taeller aldrig som "andet produkt".
      (cart.items || []).forEach(function (it) { if (!erUndtaget(it.handle) && !hasGaveProp(it)) handles[it.handle] = true; });
      var hasPro = !!handles['zen-pro'];
      var hasPulse = !!handles['zen-pulse'];
      var distinct = Object.keys(handles).length;

      var code = '';
      if (distinct >= 2) code = CODE_RUTINE;           // 2+ DISTINCT products, never 2-same
      if (BUNDLE_395_WINS && hasPro && hasPulse && distinct === 2) {
        // EXACTLY Pro+Pulse: the 395 kr bundle story won here from 2026-07-06.
        // Slaaet fra 13/10 2026 (Benjis beslutning punkt 3): kurven viser KUN
        // 15 %-beskeden, saa 2 forskellige varer giver ALTID ZN-RUT15, ogsaa
        // Zen Pro + Zen Pulse (15 % af begge er mere end 200 kr). Koden
        // bliver staaende bag BUNDLE_395_WINS.
        code = CODE_PRO_PULSE;
      }

      return setDiscount(code).then(function () {
        return getCart().then(function (c2) {
          // Tjekkes paa ordre-rabatterne (cart_level_discount_applications),
          // ikke total_discount: den indeholder ogsaa e-bogens 249 kr fra den
          // automatiske "Koeb X, faa Y"-rabat (13/10 2026).
          var lvl = (c2 && c2.cart_level_discount_applications) || [];
          if (code === '' && lvl.length !== 0) {
            console.warn('[ZenCart] clear ikke effektiv — ordre-rabatter: ' + lvl.map(function (x) { return x.title; }).join(', ') + ' (skal validere /cart/update.js {discount:""}).');
          } else if (code !== '' && !lvl.some(function (x) { return x.title === code; })) {
            console.warn('[ZenCart] code "' + code + '" gav ingen rabat — findes den (aktiv) i Admin?');
          }
          return c2;
        });
      });
    }).catch(function () { /* never break the cart flow */ });
  }

  // route -> re-render (used after every add/change/remove)
  // Paa /cart er beskeden, forslagene og totalerne Liquid; efter en aendring
  // fra skuffen eller et forslagskort genindlaeses siden, saa de passer.
  function syncCart() {
    return routeDiscounts()
      .then(function () { return refresh(); })
      .then(function (n) { if (onCartPage()) window.location.reload(); return n; });
  }
  // route -> re-render -> open (used by add-to-cart entry points)
  function syncCartAndOpen() {
    return routeDiscounts()
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); })
      .catch(function () { openDrawer(); });
  }

  /* ---- Cart normalizer: unitQty <-> pack/single composition ------------- */
  // In-flight /cart/update.js promises. Checkout waits on these so a customer
  // can't leave for checkout with a composition POST still on the wire.
  var inflight = [];
  function trackInflight(p) {
    inflight.push(p);
    var done = function () {
      var i = inflight.indexOf(p);
      if (i > -1) inflight.splice(i, 1);
    };
    p.then(done, done);
    return p;
  }

  // Compose a target unitQty from a product's real per-unit SKUs (each
  // {id, units}). For qty >= 2 we use ONLY the 2-stk + 3-stk packs, never the
  // single, so every unit lands on the 2-pak unit price (2->2-stk, 3->3-stk,
  // 4->2×2-stk, 5->3-stk+2-stk, 6->3×2-stk). Returns { variantId: quantity }
  // with EVERY known variant set (unused ones to 0) so update.js is absolute.
  function composeUnits(variants, unitQty) {
    var updates = {};
    variants.forEach(function (v) { updates[String(v.id)] = 0; });
    if (unitQty <= 0) return updates;

    var byUnits = {};
    variants.forEach(function (v) { byUnits[v.units] = String(v.id); });

    if (unitQty === 1 && byUnits[1]) {
      updates[byUnits[1]] = 1;
      return updates;
    }
    if (unitQty >= 2 && byUnits[2] && byUnits[3]) {
      var threes = (unitQty % 2 === 1) ? 1 : 0; // odd -> one 3-pak, rest 2-paks
      updates[byUnits[3]] = threes;
      updates[byUnits[2]] = (unitQty - threes * 3) / 2;
      return updates;
    }
    // Fallback (a needed pack is missing): greedy largest-first; reaches the
    // single only as a last resort so the total still sums exactly.
    var packs = variants.slice().sort(function (a, b) { return b.units - a.units; });
    var rem = unitQty;
    packs.forEach(function (v) {
      var q = Math.floor(rem / v.units);
      updates[String(v.id)] = q;
      rem -= q * v.units;
    });
    return updates;
  }

  function parseVariants(row) {
    try { return JSON.parse(row.getAttribute('data-variants') || '[]'); }
    catch (e) { return []; }
  }

  // RAW: only POST the composition to Shopify. No route, no re-render. Used both
  // by the normal path (below) and by flushPendingUnits() at checkout, where we
  // must not trigger extra refreshes.
  function setUnitQtyRaw(variants, unitQty) {
    if (!variants || !variants.length) return Promise.resolve();
    if (unitQty < 0) unitQty = 0;
    var updates = composeUnits(variants, unitQty);
    return trackInflight(fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }));
  }

  // Normal path: raw update, then route + re-render the drawer.
  function setUnitQty(variants, unitQty) {
    return setUnitQtyRaw(variants, unitQty).then(function () { return syncCart(); });
  }

  // Debounced per-handle so a burst of +/- clicks doesn't re-render mid-tap.
  // The count updates optimistically on each click; the Cart API + route + render
  // run once, ~350ms after the last click. pendingUnits holds the latest desired
  // unitQty per handle so checkout can flush anything still waiting on its timer.
  var unitTimers = {};
  var pendingUnits = {};
  function queueUnit(handle, variants, unitQty) {
    pendingUnits[handle] = { variants: variants, unitQty: unitQty };
    clearTimeout(unitTimers[handle]);
    unitTimers[handle] = setTimeout(function () {
      delete unitTimers[handle];
      var pend = pendingUnits[handle];
      delete pendingUnits[handle];
      if (pend) setUnitQty(pend.variants, pend.unitQty);
    }, 350);
  }

  // Fire any +/- still waiting on its debounce timer, then resolve only once
  // every in-flight /cart/update.js has landed. Uses the RAW writer (no per-item
  // refresh) — checkout routes + submits afterwards, so a re-render would be
  // wasted. No loop: raw never calls syncCart/queueUnit.
  function flushPendingUnits() {
    Object.keys(pendingUnits).forEach(function (handle) {
      clearTimeout(unitTimers[handle]);
      delete unitTimers[handle];
      var pend = pendingUnits[handle];
      delete pendingUnits[handle];
      if (pend) setUnitQtyRaw(pend.variants, pend.unitQty);
    });
    return Promise.all(inflight.slice());
  }

  // Catch-all add-to-cart: handle any /cart/add form that isn't already handled
  // by its own inline script (those preventDefault first).
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) btn.classList.remove('loading');
        syncCartAndOpen();
      })
      .catch(function () {
        if (btn) btn.classList.remove('loading');
      });
  }, false);

  // Quantity +/- inside the drawer — steps unitQty for the whole product.
  // Capture phase + stopImmediatePropagation so Motion's own handler can't
  // double-fire on the injected markup.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-qty__adjust') : null;
    if (!btn || !btn.closest('#CartDrawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var row = btn.closest('.cart__item');
    var wrap = btn.closest('.js-qty__wrapper');
    var count = wrap && wrap.querySelector('.js-qty__count');
    if (!row || !count) return;

    var handle = row.getAttribute('data-handle');
    var variants = parseVariants(row);
    if (!handle || !variants.length) return;

    var current = parseInt(count.textContent, 10) || 0;
    var isPlus = btn.classList.contains('js-qty__adjust--plus');
    var next = isPlus ? current + 1 : current - 1;
    if (next < 0) next = 0;

    count.textContent = next; // optimistic: instant, never hops back (stable line)
    queueUnit(handle, variants, next);
  }, true);

  // Trash removes the whole product — every underlying variant to 0.
  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('.js-cart-remove') : null;
    if (!rm || !rm.closest('#CartDrawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var row = rm.closest('.cart__item');
    if (!row) return;
    // E-bogen: kun kundens egen linje slettes, via sin linjenoegle, saa den
    // automatiske linje aldrig ryger med (13/10 2026).
    var lineKey = rm.getAttribute('data-key');
    if (lineKey) {
      postCart('cart/change.js', { id: lineKey, quantity: 0 })
        .then(function () { return syncCart(); })
        .catch(function () {});
      return;
    }
    var variants = parseVariants(row);
    if (variants.length) setUnitQty(variants, 0);
  }, true);

  // Checkout: (1) flush any pending +/- so the cart holds the customer's latest
  // quantity, (2) let the router apply the correct code, then (3) submit. Without
  // the flush, a fast "+ then checkout" could leave for checkout with old qty.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.zcart__checkout') : null;
    if (!btn || !btn.closest('#CartDrawer')) return;
    e.preventDefault();
    flushPendingUnits()
      .then(function () { return routeDiscounts(); })
      .then(function () {
        var form = btn.form || document.getElementById('CartDrawerForm');
        if (form && form.requestSubmit) form.requestSubmit(btn);
        else if (form) form.submit();
        else window.location.href = root + 'checkout';
      })
      .catch(function () { window.location.href = root + 'checkout'; });
  }, true);

  // Safety net: make sure closing the drawer never leaves the visitor locked.
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.js-drawer-close'))) return;
    var d = document.getElementById('CartDrawer');
    if (d) setTimeout(function () { d.classList.remove('is-active'); }, 60);
  });

  // B1 (19/10 2026): "Forventet levering ons. 21. til fre. 23. okt." under "Fri levering" i
  // skuffen. Dagene kommer fra Liquid: ved sideindlaesning data-zlev-cart paa
  // selve linjen (cart-drawer.liquid), efter hver aendring data-zlev paa
  // .cart__items fra cart.ajax. "pre" (forudbestilling) eller "" = ingen dato.
  // Selve datoen regnes af window.ZenLevering (snippets/zenoura-leveringsdato.liquid).
  function renderCartDelivery() {
    try {
      var el = document.querySelector('#CartDrawer [data-zlev-cart]');
      if (!el) return;
      var items = document.querySelector('#CartDrawer .cart__items');
      var days = (items && items.hasAttribute('data-zlev')) ? items.getAttribute('data-zlev') : el.getAttribute('data-zlev-cart');
      var r = (window.ZenLevering && days && days !== 'pre') ? window.ZenLevering.fraTekst(days + ' hverdage') : null;
      if (r && r.tekst) { el.textContent = 'Forventet levering ' + r.tekst; el.hidden = false; }
      else { el.textContent = ''; el.hidden = true; }
    } catch (e) { /* never break the cart flow */ }
  }

  // In-cart upsell: EEN besked (Benji 13/10 2026, punkt 3). Tilstande,
  // skrevet paa boksen som data-zcart-state:
  //   none  = tom kurv, eller 2+ varer uden at rutinerabatten (endnu) er paa
  //   one   = 1 vare (een handle, ogsaa 2 stk-pakken): OFFER_ONE + hoejst 2 kort
  //   saved = 2+ forskellige varer, ZN-RUT15 er paa: "15 % er trukket fra. Du
  //           sparer X." med X = Shopifys total_allocated_amount. Ingen kort.
  //   plain = B3 (19/10 2026): rutinerabatten er slaaet fra (data-zen-rutine="off"
  //           paa body), kurven har varer: OFFER_PLAIN + hoejst 2 kort. Forslagene
  //           maa aldrig forsvinde sammen med rabatten (fem af otte i toppen har
  //           tilkoeb i kurven uden nogen rabat).
  function updateUpsell() {
    var wrap = document.querySelector('[data-zcart-upsell]');
    if (!wrap) return;
    getCart()
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (it) { if (!erUndtaget(it.handle)) inCart[it.handle] = true; });
        var distinct = Object.keys(inCart).length;
        var cards = wrap.querySelectorAll('.zcart__up-card');
        var titleEl = wrap.querySelector('[data-zcart-upsell-title]');
        var hasZenPro = !!inCart['zen-pro'];
        var shown = 0, bundleShown = false;

        // Rutinerabattens beloeb, direkte fra Shopify (aldrig regnet ud fra 15 %).
        var rut = 0, pct = 15;
        (cart.cart_level_discount_applications || []).forEach(function (a) {
          if (String(a.title || '').indexOf('RUT') === -1) return;
          rut += Number(a.total_allocated_amount) || 0;
          if (a.value_type === 'percentage' && a.value) pct = Math.round(parseFloat(a.value)) || pct;
        });

        var rutineOff = !!(document.body && document.body.getAttribute('data-zen-rutine') === 'off');
        var state = 'none';
        if (distinct > 0) {
          if (rutineOff) state = 'plain';
          else if (distinct === 1) state = 'one';
          else if (rut > 0) state = 'saved';
        }
        wrap.setAttribute('data-zcart-state', state);

        cards.forEach(function (c) { c.hidden = true; c.classList.remove('is-bundle'); });

        // 1) Bundle nudge (kun hvis BUNDLE_395_WINS): Zen Pulse til 395, naar
        // kurven alene rummer Zen Pro.
        if (BUNDLE_395_WINS && state === 'one' && hasZenPro && !inCart['zen-pulse']) {
          var pulse = wrap.querySelector('.zcart__up-card[data-up-handle="zen-pulse"]');
          if (pulse) { pulse.hidden = false; pulse.classList.add('is-bundle'); shown++; bundleShown = true; }
        }

        // 2) Forslag: hoejst 2 varer, der ikke ligger i kurven. Kun i 1-vare-
        // tilstanden; med 2+ varer er tilbuddet opfyldt, og kortene forsvinder.
        // Black Month (3/11 2026): gaven (Recover mini) foreslaas aldrig som koeb, mens
        // gave-reglen er aktiv; bjaelken siger allerede, at den foelger gratis med.
        var gaveEl = document.querySelector('[data-zen-gave-handle]');
        var gaveHandle = gaveEl ? String(gaveEl.getAttribute('data-zen-gave-handle') || '').trim() : '';
        if (state === 'one' || state === 'plain') {
          cards.forEach(function (c) {
            if (shown >= 2 || !c.hidden) return;
            var h = c.getAttribute('data-up-handle');
            if (inCart[h] || erUndtaget(h)) return;
            if (gaveHandle && h === gaveHandle) return;
            if (h === 'zen-pulse' && bundleShown) return;
            c.hidden = false; shown++;
          });
        }

        if (titleEl) {
          if (state === 'saved') {
            titleEl.textContent = pct + ' % er trukket fra. Du sparer ' + fmtKr(rut) + '.';
          } else if (state === 'plain') {
            titleEl.textContent = OFFER_PLAIN;
          } else if (state === 'one' && !bundleShown) {
            titleEl.textContent = OFFER_ONE;
          } else if (bundleShown) {
            // Read the bundle price from the drawer card (computed server-side
            // as price minus 200 kr) so there is a single source for the number.
            var bpEl = wrap.querySelector('.zcart__up-card[data-up-handle="zen-pulse"] .zcart__up-price-bundle strong');
            var bp = bpEl && bpEl.textContent ? bpEl.textContent.trim() : '395 kr';
            titleEl.textContent = 'Tilføj Recover mini for kun ' + bp;
          }
          // Taelles paa handle (distinct), ikke cart.item_count: item_count er
          // summen af quantity, saa 2 stk-pakken af EEN vare ville ellers tælle
          // som 2 og faa "trukket fra"-linjen, selv om rabatten ikke er paa.
          // Med BUNDLE_395_WINS = false giver ogsaa Zen Pulse + Zen Pro 15 %,
          // saa opfordringen er sand for alle 1-vare-kurve (rettet 13/10 2026).
        }

        // Boksen vises i 1-vare-tilstanden (ogsaa uden ledige forslag, for
        // opfordringen er stadig sand). I plain-tilstanden kun med mindst eet
        // forslag: "Passer til din kurv" uden kort ville vaere en tom overskrift.
        wrap.hidden = !(state === 'one' || (state === 'plain' && shown > 0));
      })
      .catch(function () {});
  }

  // "Tilføj" on an upsell card -> add the variant, then route + refresh the open drawer.
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-up-add]') : null;
    if (!add) return;
    e.preventDefault();
    var vid = add.getAttribute('data-up-add');
    if (!vid) return;
    add.classList.add('loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { add.classList.remove('loading'); return syncCart(); })
      .catch(function () { add.classList.remove('loading'); });
  });

  window.ZenCart = {
    refresh: refresh,
    open: openDrawer,
    refreshAndOpen: syncCartAndOpen,
    route: routeDiscounts,
    setUnitQty: setUnitQty
  };

  // On load: carts can arrive without an add-event (cart permalinks from
  // find-solution's no-JS fallback, shared links, back-navigation), so route
  // once when the cart holds items — then the drawer, totals and upsell all
  // reflect the right code before the customer can reach checkout.
  function initCart() {
    // Black Month-gaven: er den blokeret i denne session (Shopify gjorde den
    // ikke gratis), skjules baren straks, saa den ikke lover noget.
    if (gaveCfg() && gaveSessionBlocked()) markGaveBlocked();
    getCart()
      .then(function (cart) {
        if (cart.item_count > 0) {
          var before = cart.total_price + '|' + cart.item_count;
          return routeDiscounts().then(function (c2) {
            // Paa /cart er beskeden og totalerne Liquid. Har routeren lige
            // aendret rabatten (fx en kurv fra et delt link) eller lagt e-bogen
            // i / taget den ud, genindlaeses siden een gang; anden gang er
            // kurven den samme, saa ingen loekke.
            if (onCartPage() && c2 && (c2.total_price + '|' + c2.item_count) !== before) {
              window.location.reload();
              return;
            }
            return refresh();
          });
        }
        updateUpsell();
        renderCartDelivery();
      })
      .catch(function () { updateUpsell(); renderCartDelivery(); });
  }

  // /cart: temaets egne +/- (Motion) aendrer linjerne uden om routeren og
  // sender "cart:updated". Saa koeres routeren (2 forskellige varer = 15 %,
  // 1 vare = ingen kode), og siden genindlaeses, saa besked og totaler passer.
  document.addEventListener('cart:updated', function () {
    if (!onCartPage()) return;
    routeDiscounts().then(function () { window.location.reload(); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCart);
  } else {
    initCart();
  }
})();
